import { z } from 'zod/v3';
import { errorMap } from '../../../../../common/utils';
import { AlgorithmJoinItemValidFormDataSchema } from './AlgorithmJoinItemValidFormDataSchema';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmJoinValidFormDataSchema.translations.json';

const { addTranslations, t } = i18nNsFactory(
  'algorithm-join-valid-form-data-schema',
);
addTranslations(translations);

export const AlgorithmJoinValidFormDataSchema = z.object({
  id: z
    .number()
    .transform((v) => v || null) // 0 -> null
    .nullable()
    .optional(),
  algorithmSourceId: z.number(
    errorMap(() => t('validation.algorithmSourceId.required')),
  ),
  joinTypeCode: z.enum(['FULL_OUTER', 'LEFT_OUTER', 'INNER']).nullable(),
  algorithmJoinItems: z.array(AlgorithmJoinItemValidFormDataSchema),
});
